<img
  *ngIf="!isEdit && !isAvancecred"
  class="logo"
  src="../assets/png/Broadfactor Logo- Preto.png"
  alt="logo broadfactor"
/>

<router-outlet></router-outlet>
